import { render, staticRenderFns } from "./Dm.vue?vue&type=template&id=348ab637&scoped=true"
import script from "./Dm.vue?vue&type=script&lang=js"
export * from "./Dm.vue?vue&type=script&lang=js"
import style0 from "./Dm.vue?vue&type=style&index=0&id=348ab637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ab637",
  null
  
)

export default component.exports